import React, { useState, useContext, useEffect } from 'react';
import { Input, Card, CardBody, Row, Col, FormGroup, Label, CustomInput, Collapse } from 'reactstrap';
import CurrencyInput from 'react-currency-input-field';
import { useForm } from 'react-hook-form';
import { EnvironmentContext } from '../../../context/Context';
import cogoToast from 'cogo-toast';
import ClientInfo from '../../recaudar/sections/ClientInfo';
import { MovesPageContext } from '../MovesPageContext';
import { faTimes, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DetailRow from '../../../components/GestionPersonaEmpresa/personDetails/DetailRow';
import ButtonIcon from '../../../components/common/ButtonIcon';
import FalconCardHeader from '../../../components/common/FalconCardHeader';
import { getTodayStr } from '../../../helpers/dateFormatters';
import { generalServices, treasureServices, creditServices } from '../../../services';
import WizardInput from '../../../components/auth/wizard/WizardInput';
import numToWords from '../../../helpers/numToWord';
import { currencyFormat as currencyNumberFormat, formatterId } from '../../../helpers/formatters';
import ModalSuccess from '../ModalSuccess';
import Spinner from 'reactstrap/lib/Spinner';
import ModalPayments from '../ModalPayments';
import RecaudoClient from '../../recaudar/childrens/RecaudoClient';
import { RecaudoContext } from '../../recaudar/RecaudoContext';
import { urlApi } from '../../../configuracion/serverConfig';
import { authSesion, headers } from "../../../helpers/authSesion";


const MovesCaja = ({ title, egreso }) => {
    const context = useContext(MovesPageContext);
    const environment = useContext(EnvironmentContext)
    const { loading, client, setLoading, handleCleanClient } = context;

    const [conceptosOptions, setConceptosOptions] = useState([]);
    const [treasuriesOptions, setTreasuriesOptions] = useState([]);

    const [selectedTreasure, setSelectedTreasure] = useState();
    const [selectedConcept, setSelectedConcept] = useState();
    const [amount, setAmount] = useState();
    const [observations, setObservations] = useState("");
    const [fecha, setFecha] = useState(getTodayStr());

    const [showSuccess, setShowSuccess] = useState();

    const [invoiceProps, setInvoiceProps] = useState();

    const [showModal, setShowModal] = useState();

    const [openSection, setOpenSection] = useState(null);
    const isOpen = openSection === 'recaudo';
    const isOpenOtros = openSection === 'otros';
    const toggleSection = (section) => setOpenSection(prev => prev === section ? null : section);
    const [clientCredits, setClientCredits] = useState([]);
    const [solicitudes, setSolicitudes] = useState([]);

    useEffect(() => {
        loadTreasuries();
        loadConcepts();
    }, []);

    useEffect(() => {
        loadClientCredits();
    }, [client]);

    const createInvoiceProps = (payload) => {
        const selectedConcept = conceptosOptions.filter(concept => concept.value == payload.idConcepto)
        const total = Number(amount)
        const montoWord = numToWords(total)

        const tempOwnProps = {
            client: client.terceroInformacion.nombreComercial || client.terceroInformacion.razonSocial ||
                `${client.terceroInformacion.nombre1} ${client.terceroInformacion.nombre2} ${client.terceroInformacion.apellido1} ${client.terceroInformacion.apellido2}`,
            clientTypeId: client.terceroInformacion.tipoIdentificacion,
            clientId: client.terceroInformacion.identificacion ? formatterId(Number(client.terceroInformacion.identificacion)) : "",
            serial: payload.consecutivo,
            ciudad: payload.ciudad,
            amount: currencyNumberFormat(total || 0),
            concept: selectedConcept[0] ? selectedConcept[0].label : "",
            sumWord: montoWord || "",
            checkCash: payload.modalidadPago == 1,
            checkWireTransfer: payload.modalidadPago == 2,
            checkPSE: false,
            checkCheque: payload.modalidadPago == 3,
            date: (payload.fecha || getTodayStr()).split('-'),
            observations: payload.observaciones,
            idCredit: payload.idCredit || "",
        }

        setInvoiceProps(tempOwnProps)
    }

    const loadClientCredits = async () => {
        if (!client?.id) {
            return;
        }
        const response = await creditServices.getCreditsByClient(client.id);
        if (!response || response.error) {
            cogoToast.error(response.msg,
                { position: 'bottom-left', heading: 'Error al cargar los créditos del cliente' });
            return;
        }
        setClientCredits(response.objResponse);

        fetch(`${urlApi}/solicitud/creditos/${client.id}`, {
            method: 'GET',
            headers,
        })
            .then(res => res.json())
            .then(data => data)
            .then(data => {
                setSolicitudes(data);
            })
            .catch(err => {
                cogoToast.error(String(err),
                    { position: 'bottom-left', heading: 'Error al cargar los créditos del cliente' });
            });
    }

    const loadTreasuries = async () => {
        if (environment.treasuries && environment.treasuries[0]) {
            setTreasuriesOptions(environment.treasuries)
            return
        }

        const res = await generalServices.getTreasuries();
        if (res.error || !res.objResponse) return;

        const tmpTreasuries = res.objResponse.map(treasure => ({
            value: treasure.tesoreria,
            label: treasure.nombre,
        }))

        setTreasuriesOptions(tmpTreasuries);

    }

    const loadConcepts = async () => {
        const types = egreso ? "T/C" : "T/D"
        const res = await generalServices.getCustomConcepts(types);
        if (res.error || !res.objResponse) return;

        const tmpConcepts = res.objResponse.map(concept => ({
            value: concept.conceptotesoreria,
            label: concept.nombre,
        }))

        setConceptosOptions(tmpConcepts);
    }

    const onSelectConcepto = value => {
        setSelectedConcept(value)
    }

    const onSelectTreasure = value => {
        setSelectedTreasure(value)
    }

    const handleSubmit = () => {
        if (!client) {
            cogoToast.warn("Por favor seleccione un tercero", { position: 'bottom-left', heading: 'Tercero' });
            return
        }

        if (!amount) {
            cogoToast.warn("Por favor seleccione complete los campos", { position: 'bottom-left', heading: 'Campos Requeridos' });
            return
        }
        setShowModal(true);
    }

    const onSubmit = async (dataPayments) => {
        setShowModal(false);
        setLoading(true)

        if (!client) {
            cogoToast.warn("Por favor seleccione un tercero", { position: 'bottom-left', heading: 'Tercero' });
            setLoading(false)
            return
        }

        if (!amount) {
            cogoToast.warn("Por favor seleccione complete los campos", { position: 'bottom-left', heading: 'Campos Requeridos' });
            setLoading(false)
            return
        }

        const payload = {
            idMovimiento: dataPayments.idMovimiento,
            tipo: egreso ? 2 : 1,
            idTercero: client.id,
            fecha: fecha || getTodayStr(),
            valor: Number(amount),
            idTesoreria: dataPayments.idTesoreria,
            idConcepto: dataPayments.conceptoTesoreria,
            idCuentaDestino: dataPayments.idCuentaDestino,
            idBancoCheque: dataPayments.idBancoCheque,
            numeroCheque: dataPayments.numeroCheque,
            observaciones: dataPayments.observacion,
            modalidadPago: dataPayments.modalidadPago,
        }

        const res = await treasureServices.setMove(payload);
        if (res.error || !res.objResponse) return;

        createInvoiceProps({
            ...payload,
            consecutivo: res.objResponse.consecutivo,
            ciudad: res.objResponse.ciudad,
            modalidadPago: dataPayments.modalidadPago,
            idCredit: dataPayments.idCredit || "",
        })

        setShowSuccess(true)
    }

    const onOk = () => {
        setLoading(false);
        setShowSuccess(false);
        setAmount();
        setSelectedConcept();
        setSelectedTreasure();
        setObservations("");
        setFecha(getTodayStr());
        handleCleanClient();
    }

    const handleCancel = () => {
        setAmount();
        setSelectedConcept();
        setSelectedTreasure();
        setObservations("");
        setFecha(getTodayStr());
        handleCleanClient();
        handleCleanClient();
    }

    return (
        <>
            <ModalPayments
                open={showModal}
                title={title}
                textBtn="Guardar"
                toggle={() => setShowModal(false)}
                data={{ total: amount }}
                onSubmit={onSubmit}
                egreso={egreso}
                solicitudes={solicitudes}
                fecha={fecha}
                setFecha={setFecha}
            />
            <ModalSuccess open={showSuccess} data={invoiceProps} onOk={onOk} egreso={egreso} />
            {loading ? (
                <Row className="py-4 d-flex justify-content-center h-100">
                    <Spinner color="primary" />
                </Row>
            ) : (
                <>
                    <ClientInfo context={MovesPageContext} title="Datos del Tercero" btnText="Buscar Tercero" terceros noCancel />
                    {!egreso && (
                        <Card className={`my-3`} >
                            <div style={{ cursor: "pointer" }} onClick={() => toggleSection('recaudo')}>
                                <FalconCardHeader title="Recaudo crédito">
                                    <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
                                </FalconCardHeader>
                            </div>
                            <Collapse isOpen={isOpen}>
                                <CardBody className="bg-light border-top px-4">
                                    <RecaudoContext.Provider value={{
                                        loading,
                                        client,
                                        clientCredits,
                                        loadClientCredits,
                                    }}>
                                        <RecaudoClient tesoreria />
                                    </RecaudoContext.Provider>
                                </CardBody>
                            </Collapse>
                        </Card>
                    )}
                    <Card className={`my-3`} >
                        <div style={{ cursor: "pointer" }} onClick={() => toggleSection('otros')}>
                            <FalconCardHeader title={egreso ? title : "Otros conceptos"}>
                                <div className='d-flex align-items-center'>
                                    {isOpenOtros && (
                                        <>
                                            <ButtonIcon onClick={e => { e.stopPropagation(); handleCancel(); }} icon={faTimes} transform="shrink-3 down-2" color="falcon-default" size="sm" className="mr-2">
                                                Cancelar
                                            </ButtonIcon>
                                            <ButtonIcon onClick={e => { e.stopPropagation(); handleSubmit(); }} transform="shrink-3 down-2" color="primary" size="sm" className="mr-2">
                                                Guardar
                                            </ButtonIcon>
                                        </>
                                    )}
                                    <FontAwesomeIcon icon={isOpenOtros ? faChevronUp : faChevronDown} />
                                </div>
                            </FalconCardHeader>
                        </div>
                        <Collapse isOpen={isOpenOtros}>
                        <CardBody className="bg-light border-top px-4">
                            <Row>
                                <Col>
                                    {/* <DetailRow title="Tesorería:" >
                      <FormGroup className="pr-4">
                        <WizardInput
                          type="select"
                          placeholder="Seleccionar"
                          tag={CustomInput}
                          name="treasure"
                          id="treasure"
                          value={selectedTreasure || 0}
                          onChange={({ target }) => {
                            onSelectTreasure(target.value);
                          }}
                          errors={[]}
                          options={treasuriesOptions}
                        />
                      </FormGroup>
                  </DetailRow> */}
                                    {/* <DetailRow title="Por Concepto de:" >
                      <FormGroup className="pr-4">
                        <WizardInput
                          type="select"
                          placeholder="Seleccionar"
                          tag={CustomInput}
                          value={selectedConcept || 0}
                          name="concepto"
                          id="concepto"
                          onChange={({ target }) => {
                            onSelectConcepto(target.value);
                          }}
                          errors={[]}
                          options={conceptosOptions}
                        />
                      </FormGroup>
                  </DetailRow> */}
                                    {/* <DetailRow title="Observaciones:" >
                      <FormGroup className="pr-4">
                        <Input
                          type="textarea"
                          id="observations"
                          value={observations}
                          maxLength={500}
                          name="observations"
                          onChange={(e) => setObservations(e.target.value)}
                        />
                      </FormGroup>
                  </DetailRow> */}
                                    <DetailRow title="Valor del Movimiento:">
                                        <FormGroup className="pr-4">
                                            <CurrencyInput
                                                className="form-control"
                                                allowNegativeValue={false}
                                                name="amount"
                                                id="amount"
                                                value={amount || 0}
                                                prefix='$'
                                                intlConfig={{ locale: 'es-CO', currency: 'COP' }}
                                                onValueChange={(v) => {
                                                    if (v) {
                                                        setAmount(Number(v.replaceAll(',', '.')))
                                                    } else {
                                                        setAmount(v)
                                                    }
                                                }}
                                                decimalScale={0}
                                                maxLength={20}
                                                placeholder="$ 0.00" />
                                        </FormGroup>
                                    </DetailRow>
                                </Col>
                                <Col lg={4}>
                                    <DetailRow title="Fecha Movimiento:" >
                                        <FormGroup>
                                            <div className="form-control">
                                                {fecha || <span className='p-2'></span>}
                                            </div>
                                        </FormGroup>
                                    </DetailRow>
                                </Col>
                            </Row>
                        </CardBody>
                        </Collapse>
                    </Card>
                </>
            )}
        </>
    )
}

export default MovesCaja